import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const L1adiffcult =
    '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3 or {q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3 or {q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3 or {q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3 or {q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3 or {q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3 or {q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3 or {q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3 or {q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3'
  const L1bdiffcult =
    '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3 or {q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3 or {q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3 or {q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3 or {q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3 or {q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3 or {q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3 or {q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3'
  const L1cdiffcult =
    '{q146.0} = 1 or {q146.0} = 2 or {q146.0} = 3 or {q146.1} = 1 or {q146.1} = 2 or {q146.1} = 3 or {q146.2} = 1 or {q146.2} = 2 or {q146.2} = 3 or {q146.3} = 1 or {q146.3} = 2 or {q146.3} = 3 or {q146.4} = 1 or {q146.4} = 2 or {q146.4} = 3 or {q146.5} = 1 or {q146.5} = 2 or {q146.5} = 3 or {q146.6} = 1 or {q146.6} = 2 or {q146.6} = 3'

  const visibleIfConditionsInit = {
    q7: '{q6} = 0',
    q8: '{q6} = 1 or {q6} = 2',
    q9: '{q6} = 1 or {q6} = 2 or {q6} = 3 or {q6} = 4 or {q6} = 5',
    q19: '{q18} = 1',

    // A14-1
    q21: '{q20.0} = 1 or {q20.1} = 1 or {q20.2} = 1',
    'q21.row0': '{q20.0} = 1',
    'q21.row1': '{q20.1} = 1',
    'q21.row2': '{q20.2} = 1',
    q22: '{q21.0} = 0 or {q21.1} = 0 or {q21.2} = 0',
    'q22.row0': '{q21.0} = 0',
    'q22.row1': '{q21.1} = 0',
    'q22.row2': '{q21.2} = 0',
    q23: '{q22.0} = 0 or {q22.1} = 0 or {q22.2} = 0',
    'q23.row0': '{q22.0} = 0',
    'q23.row1': '{q22.1} = 0',
    'q23.row2': '{q22.2} = 0',

    // B1
    q25: '{q24} = 0',
    q26: '{q25} = "other"',
    q27: '{q24} = 1 or {q24} = 2 or {q24} = "other"',
    q28: '{q27} = 1',
    // C1
    q30: '{q29} = 3 or {q29} = 4',

    // G1
    q39: '{q38.0} = 1 or {q38.1} = 1 or {q38.2} = 1 or {q38.3} = 1 or {q38.4} = 1 or {q38.5} = 1 or {q38.6} = 1 or {q38.7} = 1',
    'q39.row0': '{q38.0} = 1',
    'q39.row1': '{q38.1} = 1',
    'q39.row2': '{q38.2} = 1',
    'q39.row3': '{q38.3} = 1',
    'q39.row4': '{q38.4} = 1',
    'q39.row5': '{q38.5} = 1',
    'q39.row6': '{q38.6} = 1',
    'q39.row7': '{q38.7} = 1',

    q40: '{q39.0} = 0',
    q41: '{q39.1} = 0',
    q42: '{q39.2} = 0',
    q43: '{q39.3} = 0',
    q44: '{q39.4} = 0',
    q45: '{q39.5} = 0',
    q46: '{q39.6} = 0',
    q47: '{q39.7} = 0',
    q48: '{q39.0} = 1 or {q39.1} = 1 or {q39.2} = 1 or {q39.3} = 1 or {q39.4} = 1 or {q39.5} = 1 or {q39.6} = 1 or {q39.7} = 1',
    'q48.row0': '{q39.0} = 1',
    'q48.row1': '{q39.1} = 1',
    'q48.row2': '{q39.2} = 1',
    'q48.row3': '{q39.3} = 1',
    'q48.row4': '{q39.4} = 1',
    'q48.row5': '{q39.5} = 1',
    'q48.row6': '{q39.6} = 1',
    'q48.row7': '{q39.7} = 1',

    // H1
    q50: '{q49.0} = 0',
    q51: '{q49.1} = 0',
    q52: '{q49.2} = 0',
    q53: '{q49.3} = 0',
    q54: '{q49.0} = 1 or {q49.1} = 1 or {q49.2} = 1 or {q49.3} = 1',
    'q54.row0': '{q49.0} = 1',
    'q54.row1': '{q49.1} = 1',
    'q54.row2': '{q49.2} = 1',
    'q54.row3': '{q49.3} = 1',
    //I1
    q57: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q58: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q59: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q60: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q61: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q62: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q63: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    q64: '{q56} = 0 or {q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
    //k1
    q66: '{q65} anyof [0, 1, 2, "other"]',
    q67: '{q65} anyof [0, 1, 2, "other"]',
    q68: '{q65} anyof [0, 1, 2, "other"]',
    q69: '{q65} anyof [0, 1, 2, "other"]',
    q70: '{q65} anyof [0, 1, 2, "other"]',
    q71: '{q69.0} = 0 or {q69.0} = 1',
    q72: '{q69.1} = 0 or {q69.1} = 1',
    q73: '{q69.2} = 0 or {q69.2} = 1',
    q74: '{q69.3} = 0 or {q69.3} = 1',
    q75: '{q69.4} = 0 or {q69.4} = 1',
    q76: '{q70} = "other"',
    //L1-1a
    q78: L1adiffcult,
    'q78.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q78.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q78.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q78.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q78.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q78.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q78.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q78.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q78.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    // L1-2a
    q79: L1adiffcult,
    'q79.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q79.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q79.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q79.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q79.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q79.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q79.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q79.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q79.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    // L1-3a
    q80: L1adiffcult,
    'q80.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q80.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q80.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q80.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q80.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q80.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q80.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q80.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q80.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    q81: '{q80.0} = 0',
    q82: '{q80.1} = 0',
    q83: '{q80.2} = 0',
    q84: '{q80.3} = 0',
    q85: '{q80.4} = 0',
    q86: '{q80.5} = 0',
    q87: '{q80.6} = 0',
    q88: '{q80.7} = 0',
    q89: '{q80.8} = 0',
    // L1-4a
    q90: '{q80.0} = 1 or {q80.1} = 1 or {q80.2} = 1 or {q80.3} = 1 or {q80.4} = 1 or {q80.5} = 1 or {q80.6} = 1 or {q80.7} = 1 or {q80.8} = 1',
    'q90.row0': '{q80.0} = 1',
    'q90.row1': '{q80.1} = 1',
    'q90.row2': '{q80.2} = 1',
    'q90.row3': '{q80.3} = 1',
    'q90.row4': '{q80.4} = 1',
    'q90.row5': '{q80.5} = 1',
    'q90.row6': '{q80.6} = 1',
    'q90.row7': '{q80.7} = 1',
    'q90.row8': '{q80.8} = 1',
    // L1-5a
    q91: L1adiffcult,
    'q91.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q91.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q91.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q91.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q91.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q91.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q91.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q91.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q91.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    // L1-6a
    q92: L1adiffcult,
    'q92.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q92.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q92.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q92.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q92.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q92.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q92.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q92.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q92.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    // L1-7a
    q93: L1adiffcult,
    'q93.row0': '{q77.0} = 1 or {q77.0} = 2 or {q77.0} = 3',
    'q93.row1': '{q77.1} = 1 or {q77.1} = 2 or {q77.1} = 3',
    'q93.row2': '{q77.2} = 1 or {q77.2} = 2 or {q77.2} = 3',
    'q93.row3': '{q77.3} = 1 or {q77.3} = 2 or {q77.3} = 3',
    'q93.row4': '{q77.4} = 1 or {q77.4} = 2 or {q77.4} = 3',
    'q93.row5': '{q77.5} = 1 or {q77.5} = 2 or {q77.5} = 3',
    'q93.row6': '{q77.6} = 1 or {q77.6} = 2 or {q77.6} = 3',
    'q93.row7': '{q77.7} = 1 or {q77.7} = 2 or {q77.7} = 3',
    'q93.row8': '{q77.8} = 1 or {q77.8} = 2 or {q77.8} = 3',
    q94: '{q93.0} = 0',
    q95: '{q93.1} = 0',
    q96: '{q93.2} = 0',
    q97: '{q93.3} = 0',
    q98: '{q93.4} = 0',
    q99: '{q93.5} = 0',
    q100: '{q93.6} = 0',
    q101: '{q93.7} = 0',
    q102: '{q93.8} = 0',
    q103: '{q93.0} = 1',
    q104: '{q93.1} = 1',
    q105: '{q93.2} = 1',
    q106: '{q93.3} = 1',
    q107: '{q93.4} = 1',
    q108: '{q93.5} = 1',
    q109: '{q93.6} = 1',
    q110: '{q93.7} = 1',
    q111: '{q93.8} = 1',
    // L1-8a
    q112: '{q93.0} = 1 or {q93.1} = 1 or {q93.2} = 1 or {q93.3} = 1 or {q93.4} = 1 or {q93.5} = 1 or {q93.6} = 1 or {q93.7} = 1 or {q93.8} = 1',
    'q112.row0': '{q93.0} = 1',
    'q112.row1': '{q93.1} = 1',
    'q112.row2': '{q93.2} = 1',
    'q112.row3': '{q93.3} = 1',
    'q112.row4': '{q93.4} = 1',
    'q112.row5': '{q93.5} = 1',
    'q112.row6': '{q93.6} = 1',
    'q112.row7': '{q93.7} = 1',
    'q112.row8': '{q93.8} = 1',

    //L1-1b
    q114: L1bdiffcult,
    'q114.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q114.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q114.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q114.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q114.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q114.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q114.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q114.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    // L1-2b
    q115: L1bdiffcult,
    'q115.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q115.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q115.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q115.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q115.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q115.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q115.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q115.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    // L1-3b
    q116: L1bdiffcult,
    'q116.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q116.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q116.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q116.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q116.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q116.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q116.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q116.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    q117: '{q116.0} = 0',
    q118: '{q116.1} = 0',
    q119: '{q116.2} = 0',
    q120: '{q116.3} = 0',
    q121: '{q116.4} = 0',
    q122: '{q116.5} = 0',
    q123: '{q116.6} = 0',
    q124: '{q116.7} = 0',
    // L1-4b
    q125: '{q116.0} = 1 or {q116.1} = 1 or {q116.2} = 1 or {q116.3} = 1 or {q116.4} = 1 or {q116.5} = 1 or {q116.6} = 1 or {q116.7} = 1',
    'q125.row0': '{q116.0} = 1',
    'q125.row1': '{q116.1} = 1',
    'q125.row2': '{q116.2} = 1',
    'q125.row3': '{q116.3} = 1',
    'q125.row4': '{q116.4} = 1',
    'q125.row5': '{q116.5} = 1',
    'q125.row6': '{q116.6} = 1',
    'q125.row7': '{q116.7} = 1',
    // L1-5b
    q126: L1bdiffcult,
    'q126.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q126.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q126.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q126.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q126.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q126.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q126.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q126.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    // L1-6b
    q127: L1bdiffcult,
    'q127.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q127.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q127.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q127.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q127.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q127.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q127.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q127.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    // L1-7b
    q128: L1bdiffcult,
    'q128.row0': '{q113.0} = 1 or {q113.0} = 2 or {q113.0} = 3',
    'q128.row1': '{q113.1} = 1 or {q113.1} = 2 or {q113.1} = 3',
    'q128.row2': '{q113.2} = 1 or {q113.2} = 2 or {q113.2} = 3',
    'q128.row3': '{q113.3} = 1 or {q113.3} = 2 or {q113.3} = 3',
    'q128.row4': '{q113.4} = 1 or {q113.4} = 2 or {q113.4} = 3',
    'q128.row5': '{q113.5} = 1 or {q113.5} = 2 or {q113.5} = 3',
    'q128.row6': '{q113.6} = 1 or {q113.6} = 2 or {q113.6} = 3',
    'q128.row7': '{q113.7} = 1 or {q113.7} = 2 or {q113.7} = 3',
    q129: '{q128.0} = 0',
    q130: '{q128.1} = 0',
    q131: '{q128.2} = 0',
    q132: '{q128.3} = 0',
    q133: '{q128.4} = 0',
    q134: '{q128.5} = 0',
    q135: '{q128.6} = 0',
    q136: '{q128.7} = 0',
    q137: '{q128.0} = 1',
    q138: '{q128.1} = 1',
    q139: '{q128.2} = 1',
    q140: '{q128.3} = 1',
    q141: '{q128.4} = 1',
    q142: '{q128.5} = 1',
    q143: '{q128.6} = 1',
    q144: '{q128.7} = 1',
    // L1-8b
    q145: '{q128.0} = 1 or {q128.1} = 1 or {q128.2} = 1 or {q128.3} = 1 or {q128.4} = 1 or {q128.5} = 1 or {q128.6} = 1 or {q128.7} = 1',
    'q145.row0': '{q128.0} = 1',
    'q145.row1': '{q128.1} = 1',
    'q145.row2': '{q128.2} = 1',
    'q145.row3': '{q128.3} = 1',
    'q145.row4': '{q128.4} = 1',
    'q145.row5': '{q128.5} = 1',
    'q145.row6': '{q128.6} = 1',
    'q145.row7': '{q128.7} = 1',

    // L1-5c
    q147: L1cdiffcult,
    'q147.row0': '{q146.0} = 1 or {q146.0} = 2 or {q146.0} = 3',
    'q147.row1': '{q146.1} = 1 or {q146.1} = 2 or {q146.1} = 3',
    'q147.row2': '{q146.2} = 1 or {q146.2} = 2 or {q146.2} = 3',
    'q147.row3': '{q146.3} = 1 or {q146.3} = 2 or {q146.3} = 3',
    'q147.row4': '{q146.4} = 1 or {q146.4} = 2 or {q146.4} = 3',
    'q147.row5': '{q146.5} = 1 or {q146.5} = 2 or {q146.5} = 3',
    'q147.row6': '{q146.6} = 1 or {q146.6} = 2 or {q146.6} = 3',
    'q147.row7': '{q146.7} = 1 or {q146.7} = 2 or {q146.7} = 3',
    // L1-6c
    q148: L1cdiffcult,
    'q148.row0': '{q146.0} = 1 or {q146.0} = 2 or {q146.0} = 3',
    'q148.row1': '{q146.1} = 1 or {q146.1} = 2 or {q146.1} = 3',
    'q148.row2': '{q146.2} = 1 or {q146.2} = 2 or {q146.2} = 3',
    'q148.row3': '{q146.3} = 1 or {q146.3} = 2 or {q146.3} = 3',
    'q148.row4': '{q146.4} = 1 or {q146.4} = 2 or {q146.4} = 3',
    'q148.row5': '{q146.5} = 1 or {q146.5} = 2 or {q146.5} = 3',
    'q148.row6': '{q146.6} = 1 or {q146.6} = 2 or {q146.6} = 3',
    'q148.row7': '{q146.7} = 1 or {q146.7} = 2 or {q146.7} = 3',
    // L1-7c
    q149: L1cdiffcult,
    'q149.row0': '{q146.0} = 1 or {q146.0} = 2 or {q146.0} = 3',
    'q149.row1': '{q146.1} = 1 or {q146.1} = 2 or {q146.1} = 3',
    'q149.row2': '{q146.2} = 1 or {q146.2} = 2 or {q146.2} = 3',
    'q149.row3': '{q146.3} = 1 or {q146.3} = 2 or {q146.3} = 3',
    'q149.row4': '{q146.4} = 1 or {q146.4} = 2 or {q146.4} = 3',
    'q149.row5': '{q146.5} = 1 or {q146.5} = 2 or {q146.5} = 3',
    'q149.row6': '{q146.6} = 1 or {q146.6} = 2 or {q146.6} = 3',
    'q149.row7': '{q146.7} = 1 or {q146.7} = 2 or {q146.7} = 3',
    q150: '{q149.0} = 0',
    q151: '{q149.1} = 0',
    q152: '{q149.2} = 0',
    q153: '{q149.3} = 0',
    q154: '{q149.4} = 0',
    q155: '{q149.5} = 0',
    q156: '{q149.6} = 0',
    q157: '{q149.0} = 1',
    q158: '{q149.1} = 1',
    q159: '{q149.2} = 1',
    q160: '{q149.3} = 1',
    q161: '{q149.4} = 1',
    q162: '{q149.5} = 1',
    q163: '{q149.6} = 1',
    // L1-8c
    q164: '{q149.0} = 1 or {q149.1} = 1 or {q149.2} = 1 or {q149.3} = 1 or {q149.4} = 1 or {q149.5} = 1 or {q149.6} = 1',
    'q164.row0': '{q149.0} = 1',
    'q164.row1': '{q149.1} = 1',
    'q164.row2': '{q149.2} = 1',
    'q164.row3': '{q149.3} = 1',
    'q164.row4': '{q149.4} = 1',
    'q164.row5': '{q149.5} = 1',
    'q164.row6': '{q149.6} = 1',

    q167: '{q166} = 1',
    q168: '{q166} = 1',

    q175: '{q174} = 1 or {q174} = 2',
    q176: '{q174} = 1 or {q174} = 2',
    q177: '{q174} = 1 or {q174} = 2',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 0)`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    sfdSamplerId,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `<p>感謝您接受本次調查！</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 0) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login || !!sfdSamplerId,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
